import styled from 'styled-components'

export default styled.div`
  margin-top: 80px;
  h1 {
    font-size: 5vmin;
    font-weight: normal;
    color: red;
  }
  p {
    font-size: 0.9375rem;
  }
`


// WEBPACK FOOTER //
// ./src/components/Page.js